import { InstantConfigGroup } from './instant-config-group';
import { InstantConfigValue } from './types';

export interface InstantConfigResponse {
	[key: string]: InstantConfigValue | InstantConfigGroup[];
}
